import DatePicker from "./index.vue";
export default DatePicker;
